
import { useState } from "react";
import { Helmet } from "react-helmet";

// import HeroSection from "../general/HeroSection";
import TextSlides from "./TextSlides";


function ConvertCase() {

  // UpperCase Function
  const handleUpClick = () => {
    let newText = text.toUpperCase();
    setText(newText);
  }

  // LowerCase Function
  const handleLoClick = () => {
    let newText = text.toLowerCase();
    setText(newText);
  }

    // Function to convert text to Title Case
    const convertToTitleCase = () => {
      const titleCaseText = text
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      setText(titleCaseText);
    };


      // Function to convert text to Sentence Case
  const convertToSentenceCase = () => {
    const sentenceCaseText = text
      .toLowerCase()
      .split(/(?<=[.?!])\s+/) // Split into sentences based on punctuation followed by space
      .map((sentence) => sentence.charAt(0).toUpperCase() + sentence.slice(1))
      .join(" ");
    setText(sentenceCaseText);
  };


  // ClearWhite Function
  const handlewhiteClick = () => {
    let newText = text.replace(/\s+/g, '');
    setText(newText);
  }

  const clearTextClick = () => {
   
    setText("");
  }

  // on change Function
  const handleOnChange = (event) => {
    setText(event.target.value)
  }

   // Function to copy text to clipboard
   const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setAlert(true); // Show alert
      setTimeout(() => setAlert(false), 2000); // Hide alert after 2 seconds
    });
  };

  // Function to remove line breaks
  const removeLineBreaks = () => {
    const updatedText = text.replace(/\n+/g, " "); // Replace all line breaks with a space
    setText(updatedText);
  };

  // Function to space to hyphen
  const convertSpacesToHyphens = () => {
    const updatedText = text.replace(/\s+/g, "-"); // Replace all spaces with hyphens
    setText(updatedText);
  };


  const [text, setText] = useState("");
  const [alert, setAlert] = useState(false);


  return (
    <>
       <Helmet>
        <title>Convert Case Online | Uppercase, Lowercase, Title Case & More using Panacea </title>
        <meta name="description" content="Easily convert text to uppercase, lowercase, title case, sentence case, and more with our free online Convert Case tool. Fast, simple, and perfect for any writing or editing task." />
      </Helmet>
      <section className=" section-padding" >
 

        <div className="container">
          <div className="section-title text-gradient text-center">Case Converter </div>
          <div className="section-subTitle text-center padd-title">
          Change Text Case is a handy web application that enables you to change the text case of any given text. <br /> Simply copy and paste the text into the text area below and click the required text case.
          </div>
          <div className="input-btn-grp pt-5">
            <div className="row">
              <div className=" col-lg-8">

                <div class="input-group mb-3">

                  <textarea class="form-control" value={text} onChange={handleOnChange} rows={12} placeholder="Type or Paste your text here" ></textarea>
                  
                </div>
              <div className="btn-alert-grp" >
                <button className="clear-btn " onClick={clearTextClick} > Clear  </button>  
                <button className="clear-btn" onClick={handleCopy} > Copy to Clipboard  </button>  
                {alert && <h5 className="copy-alert" > Copied to Clipboard ! </h5> }

              </div>
              </div>
              <div className=" col-lg-4">
              <div className="change-text md-padd-top-30">Change My Text To..</div>
                <div className="btn-grp ">
                 
                  <button className="custom-btn1" onClick={handleUpClick}> UPPERCASE </button>
                  <button className="custom-btn1" onClick={handleLoClick} > lowercase </button>
                </div>
                <div className="btn-grp ">
                 
                <button className="custom-btn1" onClick={convertToTitleCase} > Title Case </button>
                <button className="custom-btn1" onClick={convertToSentenceCase} > Sentence case </button>
                </div>

                <div className="change-text" >Remove From My Text..</div>
                <div className="btn-grp ">
                 
                <button className="custom-btn2" onClick={handlewhiteClick} > Remove Space </button>
                <button className="custom-btn2" onClick={removeLineBreaks} > Remove Line Breaks </button>
                </div>
                <div className="btn-grp ">
                 
                <button className="custom-btn2" onClick={convertSpacesToHyphens} >  Space To --  </button>
                <button className="custom-btn2" onClick={removeLineBreaks} > Remove Line Breaks </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding"> 
        <div className="container">
        <TextSlides/>   
        </div>
         </section>

    </>
  );
};



export default ConvertCase;
